import { Form } from '@/components/lemonadeGoesGlobal/Form';
import { Hero } from '@/components/lemonadeGoesGlobal/Hero';
import { LemonadeGoesGlobalContent } from '@/components/lemonadeGoesGlobal/LemonadeGoesGlobalContent';
import { GlobalMap } from '@/components/lemonadeGoesGlobal/map/GlobalMap';
import { PageWrapper } from '@/components/shared/Content';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { useShowHeaderCtaOnScroll } from '@/hooks/useShowHeaderCtaOnScroll';
import type { Config } from '@/pageConfig/lemonadeGoesGlobal';
import { DialogProvider } from '@lemonade-hq/cdk';
import type { Locale } from '@lemonade-hq/lemonation';
import { DocumentTypes } from 'contentlayer/generated';

export type Region = 'us' | 'eu';
export type Product =
  | 'homeowners'
  | 'landlords'
  | 'renters'
  | 'contents'
  | 'liability'
  | 'contents_and_liability'
  | 'pet'
  | 'life'
  | 'car';

type Available = { product: Product; available: string[] };
export type Data = Record<Region, Available[]>;

interface LemonadeGoesGlobalPageTemplateProps {
  config: Config;
  data: Data;
  locale: Locale;
}

// TOOD: maybe add a pageview event here
export const LemonadeGoesGlobalPageTemplate: React.FC<LemonadeGoesGlobalPageTemplateProps> = ({
  config,
  data,
  locale,
}) => {
  useShowHeaderCtaOnScroll(true);

  return (
    <>
      <SEO {...config.seo} />
      <Layout pt={[100, 160]} {...config.layout}>
        <PageWrapper>
          <Hero {...config.hero}>
            <DialogProvider>
              <Form locale={locale} data={data} />
            </DialogProvider>
            <GlobalMap locale={locale} />
          </Hero>
          <LemonadeGoesGlobalContent
            content={config.MDXContent as DocumentTypes}
            {...('logo' in config && { logo: config.logo })}
          />
        </PageWrapper>
      </Layout>
    </>
  );
};
